/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { Button } from "components/button";
import { CustomModal } from "components/custom-modal";
import { Input } from "components/input";
import { SelectInput } from "components/select";
import Invoice from "container/invoice";
import { InputWrapper } from "styles/form";
import { CountriesList } from "utils/countries-list";
import { SchoolApplicationFormContainer } from "./school-application.style";

const genderData = [
   {
      label: "Male",
      value: "male",
   },
   {
      label: "Female",
      value: "female",
   },
];

const religionData = [
   {
      label: "Christainity",
      value: "christainity",
   },
   {
      label: "Islam",
      value: "islam",
   },
];

export const SchoolApplicationForm = ({ school }) => {
   const [isLoading, setIsLoading] = useState(false);
   const [currentStates, setCurrentStates] = useState<any[]>([]);
   const [modalVisibility, setModalVisibility] = useState(false);
   const [payload, setPayload] = useState<Record<string, string>>({});
   const [currentCountries, _setCurrentCountries] = useState(() =>
      CountriesList.map((c) => ({ label: c.name, value: c.name.toLowerCase() }))
   );

   const close = () => setModalVisibility(false);
   const schema = yup.object().shape({
      pupilLastName: yup.string().required("Last name is a required field"),
      pupilOtherName: yup.string().required("Other name is a required field"),
      pupilGender: yup.string().required("Gender is a required field"),
      pupilDOB: yup.string().required("Date of birth is a required field"),
      pupilResidentialAddress: yup.string().required("Residential address is a required field"),
      nationality: yup.string().required("Nationality is a required field"),
      stateOfOrigin: yup.string().required("State of origin is a required field"),
      postalAddress: yup.string().required("Postal Address field is a required field"),
      class: yup.string().required("Class field is a required field"),
      pupilBirthplace: yup.string().required("Pupil Birth place field is a required field"),
      religion: yup.string().required("Religion is a required field"),
      currentSchool: yup.string().required("Current School is a required field"),
   });

   const {
      handleSubmit,
      register,
      formState: { errors, isValid },
      control,
      getValues,
   } = useForm<any>({
      resolver: yupResolver(schema),
      mode: "onChange",
   });

   useEffect(() => {
      const currentState = CountriesList.find(
         (country) => country.name.toLowerCase() === getValues()?.country
      )?.states.map((el) => ({ value: el.name.toLowerCase(), label: el.name }));
      setCurrentStates(currentState as any[]);
   }, [getValues().country]);

   function handleCurrentStates(countryName) {
      setCurrentStates([]);
      const currentState = CountriesList.find(
         (country) => country.name.toLowerCase() === countryName
      )?.states.map((el) => ({ value: el.name.toLowerCase(), label: el.name }));
      setCurrentStates(currentState as any[]);
   }

   async function submit(values: Record<string, string>) {
      setIsLoading(false);
      setModalVisibility(true);
      setPayload(values);
   }

   return (
      <SchoolApplicationFormContainer>
         <h3 className="title">{school.name} Application Form</h3>
         <p className="brief">
            Kindly fill the form below so the school can follow up with you shortly.
         </p>

         <CustomModal visible={modalVisibility} handleClose={close}>
            <Invoice school={school} payload={payload} />
         </CustomModal>

         <form onSubmit={handleSubmit(submit)}>
            <InputWrapper className="grid-2-2 mt-15">
               <Input
                  label="Pupil Name "
                  id="pupilOtherName"
                  type="text"
                  {...register("pupilOtherName")}
                  error={errors.pupilOtherName?.message}
               />
               <Input
                  label="Pupil Last Name"
                  id="pupilLastName"
                  type="text"
                  {...register("pupilLastName")}
                  error={errors.pupilLastName?.message}
               />
            </InputWrapper>
            <InputWrapper className="grid-2-2 mt-15">
               <Controller
                  control={control}
                  name="pupilGender"
                  render={({ field: { onChange } }) => (
                     <>
                        <SelectInput
                           id="pupilGender"
                           label="Gender"
                           onChange={(data) => onChange(data?.value)}
                           placeholder="Select Gender"
                           error={errors.pupilGender?.message}
                           options={genderData}
                        />
                     </>
                  )}
               />
               <Input
                  label="Date Of Birth"
                  id="pupilDOB"
                  type="date"
                  {...register("pupilDOB")}
                  error={errors.pupilDOB?.message}
               />
            </InputWrapper>
            <InputWrapper className="grid-2-2 mt-15">
               <Input
                  label="Pupil Place of Birth"
                  id="pupilBirthplace"
                  type="text"
                  {...register("pupilBirthplace")}
                  error={errors.pupilBirthplace?.message}
               />
               <Input
                  label=" Pupil Class"
                  id="class"
                  type="text"
                  {...register("class")}
                  error={errors.class?.message}
               />
            </InputWrapper>

            <InputWrapper>
               <Input
                  label="Residental Address"
                  id="pupilResidentialAddress"
                  type="text"
                  {...register("pupilResidentialAddress")}
                  error={errors.pupilResidentialAddress?.message}
               />
            </InputWrapper>

            <InputWrapper className="grid-2-2 mt-15">
               <Input
                  label="Postal Address"
                  id="postalAddress"
                  type="text"
                  {...register("postalAddress")}
                  error={errors.postalAddress?.message}
               />
               <Input
                  label="Present School"
                  id="currentSchool"
                  type="text"
                  {...register("currentSchool")}
                  error={errors.currentSchool?.message}
               />
            </InputWrapper>

            <InputWrapper className="grid-2-2 mt-15">
               <Controller
                  control={control}
                  name="nationality"
                  render={({ field: { onChange } }) => (
                     <>
                        <SelectInput
                           label="Country"
                           id="country"
                           type="text"
                           isClearable
                           placeholder="Country"
                           onChange={(val: any) => {
                              onChange(val?.value);
                              handleCurrentStates(val?.value);
                           }}
                           error={errors.country?.message}
                           options={currentCountries}
                        />
                     </>
                  )}
               />
               <Controller
                  control={control}
                  name="stateOfOrigin"
                  render={({ field: { onChange } }) => (
                     <>
                        <SelectInput
                           label="State"
                           id="state"
                           type="text"
                           key={getValues().country}
                           placeholder="State of Origin"
                           onChange={(val: any) => onChange(val?.value)}
                           error={errors.state?.message}
                           options={currentStates}
                        />
                     </>
                  )}
               />
            </InputWrapper>
            <InputWrapper className="grid-2-2 mt-15">
               <Controller
                  control={control}
                  name="religion"
                  render={({ field: { onChange } }) => (
                     <>
                        <SelectInput
                           label="Religion"
                           id="religion"
                           onChange={(data) => onChange(data?.value)}
                           placeholder="Select School"
                           error={errors.religion?.message}
                           options={religionData}
                        />
                     </>
                  )}
               />
               <Input
                  label="Relationship To Pupil"
                  id="relationToPupil"
                  type="text"
                  {...register("relationToPupil")}
                  error={errors.currentSchool?.message}
               />
            </InputWrapper>
            <div className="btn-div">
               <Button
                  disabled={isLoading || !isValid}
                  type="submit"
                  variant="primary"
                  isLoading={isLoading}
               >
                  Submit
               </Button>
            </div>
         </form>
      </SchoolApplicationFormContainer>
   );
};
